import Vue from 'vue'
import VueRouter from 'vue-router'
import { Auth } from 'aws-amplify'

import LoginPage from '@/components/pages/LoginPage'
import SystemErrorPage from '@/components/pages/SystemErrorPage'
import IndexPage from '@/components/pages/IndexPage'
import RegistrationSymbolMasterPage from '@/components/pages/master/registrationSymbolMaster/RegistrationSymbolMasterPage'
import CustomerMasterPage from '@/components/pages/master/customerMaster/CustomerMasterPage'
import AirportMasterPage from '@/components/pages/master/airportMaster/AirportMasterPage'
import UserMasterPage from '@/components/pages/master/cognitoUserMaster/UserMasterPage'
import FlightDataPage from '@/components/pages/data/flightData/FlightDataPage.vue'
import HangarUsagesDataPage from '@/components/pages/data/hangarUsagesData/HangarUsagesDataPage.vue'
import MergeDataPage from '@/components/pages/data/mergeData/MergeDataPage.vue'
import LandingPassengersDataPage from '@/components/pages/data/landingPassengersData/LandingPassengersDataPage'
import TakeoffPassengersDataPage from '@/components/pages/data/takeoffPassengersData/TakeoffPassengersDataPage'
import FeesForWeightAndNoisePage from '@/components/pages/calculation/feesForWeightAndNoise/FeesForWeightAndNoisePage.vue'
import FeesForPaidPassengersPage from '@/components/pages/calculation/feesForPaidPassengers/FeesForPaidPassengersPage.vue'
import FeesForStopPage from '@/components/pages/calculation/feesForStop/FeesForStopPage.vue'
import FeesForSecurityPage from '@/components/pages/calculation/feesForSecurity/FeesForSecurityPage.vue'
import InvoiceOperationPage from '@/components/pages/invoice/invoiceOperation/InvoiceOperationPage.vue'
import InvoiceInquiryPage from '@/components/pages/invoice/invoiceInquiry/InvoiceInquiryPage.vue'
import FeesForWeightAndNoiseMasterPage from '@/components/pages/feeMaster/feesForWeightAndNoiseMaster/FeesForWeightAndNoiseMasterPage.vue'
import FeesForPaidPassengersMasterPage from '@/components/pages/feeMaster/feesForPaidPassengersMaster/FeesForPaidPassengersMasterPage.vue'
import FeesForStopMasterPage from '@/components/pages/feeMaster/feesForStopMaster/FeesForStopMasterPage.vue'
import FeesForSecurityMasterPage from '@/components/pages/feeMaster/feesForSecurityMaster/FeesForSecurityMasterPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginPage,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/system-error',
    name: 'SystemError',
    component: SystemErrorPage,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/index',
    component: IndexPage
  },
  {
    path: '/master/registration-symbol-master',
    component: RegistrationSymbolMasterPage
  },
  {
    path: '/master/customer-master',
    component: CustomerMasterPage
  },
  {
    path: '/master/airport-master',
    component: AirportMasterPage
  },
  {
    path: '/master/user-master',
    component: UserMasterPage
  },
  {
    path: '/data/flight-data',
    component: FlightDataPage
  },
  {
    path: '/data/hangar-usages-data',
    component: HangarUsagesDataPage
  },
  {
    path: '/data/merge-data',
    component: MergeDataPage
  },
  {
    path: '/data/landing-passengers-data',
    component: LandingPassengersDataPage
  },
  {
    path: '/data/takeoff-passengers-data',
    component: TakeoffPassengersDataPage
  },
  {
    path: '/calculation/fees-for-weight-and-noise',
    component: FeesForWeightAndNoisePage
  },
  {
    path: '/calculation/fees-for-paid-passengers',
    component: FeesForPaidPassengersPage
  },
  {
    path: '/calculation/fees-for-stop',
    component: FeesForStopPage
  },
  {
    path: '/calculation/fees-for-security',
    component: FeesForSecurityPage
  },
  {
    path: '/invoice/invoice-operation',
    component: InvoiceOperationPage
  },
  {
    path: '/invoice/invoice-inquiry',
    component: InvoiceInquiryPage
  },
  {
    path: '/fee-master/fees-for-weight-and-noise',
    component: FeesForWeightAndNoiseMasterPage
  },
  {
    path: '/fee-master/fees-for-paid-passengers',
    component: FeesForPaidPassengersMasterPage
  },
  {
    path: '/fee-master/fees-for-stop',
    component: FeesForStopMasterPage
  },
  {
    path: '/fee-master/fees-for-security',
    component: FeesForSecurityMasterPage
  }
]

const router = new VueRouter({
  // mode: 'history',  // パスに#を含めるためコメント
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  document.body.querySelectorAll('.el-dialog__wrapper').forEach(x => x.remove())
  if (to.matched.some(record => !record.meta.isPublic)) {
    Auth.currentSession()
      .then(res => {
        next()
      })
      .catch(e => {
        next({ path: '/' })
      })
  } else {
    next()
  }
})

export default router
